export function isFunction(v) {
    return typeof v === 'function';
}
//# sourceMappingURL=is-function.js.map